import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { DebtorService } from '../_services/debtor.service';
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService } from '../_helpers/index';

import { ParameterData } from '../_helpers/index';
import { Router } from '@angular/router';
import { Status, Overduedate, ExpirationRank, Creation } from '../_enums/invoice';
import { DataService } from '../_helpers/dataservice.service'
import { Invoice } from '../_models';
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { Title } from '@angular/platform-browser';

@Component({
  selector: 'salesinvoicelist',
  templateUrl: './salesinvoicelist.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})
export class SalesInvoicesListComponent implements OnInit, OnDestroy {

  public customer_public_id: string;

  excelExportData: any;
  ddlStatus: any[];
  ddlExpirationPRank: any[];
  ddlExpirationRank: any[];
  ddlCreation: any[];

  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  searchExpirationFilterForm: FormGroup;
  searchOverdueFilterForm: FormGroup;
  displayedColumns: string[] = ['select', 'created', 'due_datetime', 'namess', 'debtor.name', 'total.value', 'status', 'actions'];
  dataSourceInvoicesList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  customerPublic_key;
  isRangoVisiable = false;
  isExpirationVisiable = false;
  isOverdueVisiable = false;
  isRangoStatus = "None";
  auth0Profile: any;
  isLoading = true;
  pageSize: number;
  PageSizeOptions: number[];
  /** This is Constructor function which is used to initialize the class variables and objects; 
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder
      , private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService, private debtorService: DebtorService
      , private invoicesService: InvoicesService
      , private creation: Creation
      , private expirationRank: ExpirationRank
      , private overduedate: Overduedate
      , private status: Status
      , private datePipe: DatePipe
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private titleService: Title
    ) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

    this.spinnerService.show();

    this.ddlStatus = status._status;

    this.isRangoVisiable = false;
    this.isExpirationVisiable = false;
    this.isOverdueVisiable = false;

    this.dataService.currentPublicKey.subscribe((data) => {
      this.customerPublic_key = data;
    });


  }//end 


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceInvoicesList.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSourceInvoicesList.data.forEach(row => this.selection.select(row));
  }


  /** This function is used to work the text filter above the grid; 
   */
  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;

    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.dataSourceInvoicesList.filter = this.filterValue;

  }//end


  /** This is ngOnInit function called after initialising the component; 
 */
  ngOnInit() {

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');

    }

    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.searchExpirationFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.searchOverdueFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    if (this.creation._creation.length > 8) {
      this.creation._creation.shift();
    }

    if (this.expirationRank._expirationRank.length > 6) {
      this.expirationRank._expirationRank.shift();
    }

    if (this.overduedate._overduedate.length > 9) {
      this.overduedate._overduedate.shift();
    }

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    this.ddlCreation = this.creation._creation;
    this.ddlExpirationRank = this.expirationRank._expirationRank;
    this.ddlExpirationPRank = this.overduedate._overduedate;
    this.GetCustomerInvoicesList();
    this.dataSourceInvoicesList.paginator = this.paginator;
    this.dataSourceInvoicesList.sort = this.sort;

  }//end

  ngOnDestroy() {

  }



  GetCustomerInvoicesList() {


    setTimeout(() => {

      this.invoicesService.getSalesInvoiceList(this.customer_public_id, '').subscribe(data => {

        let resources = data["data"];
        this.isLoading = false;

        this.dataSourceInvoicesList.data = resources;
        this.excelExportData = resources;

        this.spinnerService.hide();
      },
        error => {
          this.isLoading = false;
          console.log('Failed! while trying to get the invoices list. ' + error);
        });


    }, 500);
    //set timeout end

  }//end

  viewInvoiceDetails(element) {
    this.dataService.changeinvoicepublicKey(element.public_id);

    this.router.navigate([`/sales/${element.public_id}/view`]);
  }

  viewDebtorDetails(element) {

    this.dataService.changepublicKey(element.debtor.public_id);

    this.router.navigate([`/customers/${element.debtor.public_id}/view`]);
  }

  filterRangoDetails() {

    if (this.creation._creation.length > 8) {
      this.creation._creation.shift();
    }

    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");

    this.ddlCreation.unshift({ value: 8, name: this.filterValue });

    this.isRangoVisiable = false;



    this.dataSourceInvoicesList.filter = '';
    let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
    let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
    this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
      data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

    this.dataSourceInvoicesList.filter = '2018-10-24 01:59:45';


  }//end


  filterStatusDetails(status) {

    if (status == this.ddlStatus[0].value) {
      this.dataSourceInvoicesList.filter = '';
    }
    else if (status == this.ddlStatus[1].value) {
      this.dataSourceInvoicesList.filter = '';

      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status.toLowerCase() == filter;

      this.filterValue = 'NEW';

      this.dataSourceInvoicesList.filter = this.filterValue.trim().toLowerCase();
    }
    else if (status == this.ddlStatus[2].value) {
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status == 'PROCESSING' || data.status === 'PAYMENT_ON_HOLD';

      this.dataSourceInvoicesList.filter = 'PAYMENT_ON_HOLD';
    }

    else if (status == this.ddlStatus[3].value) {
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status == 'PAID';

      this.dataSourceInvoicesList.filter = 'PAID';
    }
    else if (status == this.ddlStatus[4].value) {
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status == 'VOIDED' || data.status === 'VOIDED_CUSTOMER';

      this.dataSourceInvoicesList.filter = 'VOIDED';
    }
    else if (status == this.ddlStatus[5].value) {
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status == 'OVERDUE';

      this.dataSourceInvoicesList.filter = 'OVERDUE';
    }
    else if (status == this.ddlStatus[6].value) {
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status == 'EXPIRED';

      this.dataSourceInvoicesList.filter = 'EXPIRED';
    }
    else if (status == this.ddlStatus[9].value) {
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status == 'VALIDATING';

      this.dataSourceInvoicesList.filter = 'VALIDATING';
    }
    else if (status == this.ddlStatus[10].value) {
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status == 'BLOCKED';

      this.dataSourceInvoicesList.filter = 'BLOCKED';
    }
    else if (status == this.ddlStatus[11].value) {
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.status == 'REVIEW';

      this.dataSourceInvoicesList.filter = 'REVIEW';
    }
  }


  filterOverdueDetails(overdue) {

    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);


    // All Datas Condition
    if (overdue == 0) {
      this.dataSourceInvoicesList.filter = '';
    }

    // Expired 90 Days or more filter condition
    if (overdue == 1) {
      this.dataSourceInvoicesList.filter = '';
      currentDate.setDate(currentDate.getDate() - 90);

      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.due_datetime >= startDate;
    }

    // Expired 60 Days or more filter condition
    if (overdue == 2) {
      this.dataSourceInvoicesList.filter = '';
      currentDate.setDate(currentDate.getDate() - 60);

      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.due_datetime >= startDate;
    }


    // Expired 30 Days or more filter condition
    if (overdue == 3) {
      this.dataSourceInvoicesList.filter = '';
      currentDate.setDate(currentDate.getDate() - 30);

      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.due_datetime >= startDate;
    }

    // Expired Less than 30 Days filter condition
    if (overdue == 4) {
      this.dataSourceInvoicesList.filter = '';
      var expiredLastDate = new Date(currentDate.getDate() - 30);
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(expiredLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.due_datetime >= endDate && data.due_datetime <= startDate;
    }
    // Expired Today Filter Condition
    if (overdue == 5) {
      this.dataSourceInvoicesList.filter = '';
      currentDate.setDate(currentDate.getDate());
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.due_datetime >= startDate && data.due_datetime <= endDate;
    }

    // Expired Current Week Filter Condition
    if (overdue == 6) {
      this.dataSourceInvoicesList.filter = '';
      let WeekstartDate = formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let WeekendDate = formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.due_datetime >= WeekstartDate && data.due_datetime <= WeekendDate;

    }

    // Expired Current Month Filter Condition
    if (overdue == 7) {
      this.dataSourceInvoicesList.filter = '';
      let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.due_datetime >= CurrentmonthFirstDate && data.due_datetime <= CurrentmonthEndDate;

    }


    if (overdue != 0) {
      this.dataSourceInvoicesList.filter = '2018-10-24 01:59:45';
    }
    // Range Filter Condition
    if (overdue == 8) {
      this.dataSourceInvoicesList.filter = '';
      this.isRangoStatus = "Overdue";
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoStatus = "None";
      this.isRangoVisiable = false;
    }

  }

  filterAllDetails() {

    if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
      && this.searchRangoFilterForm.controls.searchFromDate.value !== '' && this.searchRangoFilterForm.controls.searchToDate.value !== ''
    ) {
      if (this.isRangoStatus == "Expired") {
        this.filterRangoExpDetails();
      }

      if (this.isRangoStatus == "Overdue") {
        this.filterRangoOverdueDetails();
      }

      if (this.isRangoStatus == "creation") {
        this.filterRangoDetails();
      }
    }
    else {

      if (this.overduedate._overduedate.length > 9) {
        this.overduedate._overduedate.shift();
      }
      if (this.expirationRank._expirationRank.length > 6) {
        this.expirationRank._expirationRank.shift();
      }

      if (this.creation._creation.length > 8) {
        this.creation._creation.shift();
      }
      this.isRangoVisiable = false;

    }

  }


  filterExpirationDetails(expiration) {
    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    // All Datas Condition
    if (expiration == 0) {
      this.dataSourceInvoicesList.filter = '';
    }


    // Today Filter Condition
    if (expiration == 1) {
      this.dataSourceInvoicesList.filter = '';
      currentDate.setDate(currentDate.getDate());
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.expiration_datetime >= startDate && data.expiration_datetime <= endDate;
    }

    // Tommorrow Filter Condition
    if (expiration == 2) {
      this.dataSourceInvoicesList.filter = '';
      currentDate.setDate(currentDate.getDate() + 1);
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');

      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.expiration_datetime >= startDate && data.expiration_datetime <= endDate;
    }

    // Current Week Filter Condition
    if (expiration == 3) {
      this.dataSourceInvoicesList.filter = '';
      let WeekstartDate = formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let WeekendDate = formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.expiration_datetime >= WeekstartDate && data.expiration_datetime <= WeekendDate;

    }


    // Current Month Filter Condition
    if (expiration == 4) {
      this.dataSourceInvoicesList.filter = '';
      let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.expiration_datetime >= CurrentmonthFirstDate && data.expiration_datetime <= CurrentmonthEndDate;

    }

    if (expiration != 0) {
      this.dataSourceInvoicesList.filter = '2018-10-24 01:59:45';
    }


    if (expiration == 5) {
      this.dataSourceInvoicesList.filter = '';
      this.isRangoStatus = "Expired";
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoStatus = "None";
      this.isRangoVisiable = false;
    }




  }

  filterRangoExpDetails() {

    if (this.expirationRank._expirationRank.length > 6) {
      this.expirationRank._expirationRank.shift();
    }

    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");

    this.ddlExpirationRank.unshift({ value: 6, name: this.filterValue });

    this.isExpirationVisiable = false;
    this.isRangoVisiable = false;


    this.dataSourceInvoicesList.filter = '';
    let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
    let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
    this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
      data.expiration_datetime >= CurrentmonthFirstDate && data.expiration_datetime <= CurrentmonthEndDate;

    this.dataSourceInvoicesList.filter = '2018-10-24 01:59:45';


  }//end



  filterRangoOverdueDetails() {

    if (this.overduedate._overduedate.length > 9) {
      this.overduedate._overduedate.shift();
    }

    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");

    this.ddlExpirationPRank.unshift({ value: 9, name: this.filterValue });

    this.isOverdueVisiable = false;
    this.isRangoVisiable = false;


    this.dataSourceInvoicesList.filter = '';
    let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
    let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
    this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
      data.due_datetime >= CurrentmonthFirstDate && data.due_datetime <= CurrentmonthEndDate;

    this.dataSourceInvoicesList.filter = '2018-10-24 01:59:45';


  }//end


  filterCreationDetails(creation) {

    this.ddlCreation = [];
    this.ddlCreation = this.creation._creation;

    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(currentweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);



    // All Datas Condition
    if (creation == 0) {
      this.dataSourceInvoicesList.filter = '';
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.dataSourceInvoicesList.filter = '';
      let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.dataSourceInvoicesList.filter = '';
      let WeekstartDate = formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let WeekendDate = formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.created >= WeekstartDate && data.created <= WeekendDate;

    }

    // Today Filter Condition
    if (creation == 3) {
      this.dataSourceInvoicesList.filter = '';
      currentDate.setDate(currentDate.getDate());
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      this.dataSourceInvoicesList.filter = '';
      currentDate.setDate(currentDate.getDate() - 1);
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }


    // Last Week Filter Condition
    if (creation == 5) {
      this.dataSourceInvoicesList.filter = '';

      let lastWeekstartDate = formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let lastWeekendDate = formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');


      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.created >= lastWeekstartDate && data.created <= lastWeekendDate;

    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.dataSourceInvoicesList.filter = '';
      let LastmonthFirstDate = formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let LastmonthEndDate = formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
        data.created >= LastmonthFirstDate && data.created <= LastmonthEndDate;

    }
    if (creation != 0) {
      this.dataSourceInvoicesList.filter = '2018-10-24 01:59:45';
    }


    // Range Filter Condition
    if (creation == 7) {
      this.dataSourceInvoicesList.filter = '';
      this.isRangoStatus = "creation";
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoStatus = "None";
      this.isRangoVisiable = false;
    }
  }//end


  /**
  * this function is used to redirect to the right component based on input.
  */
  invoicegridActionClick(viewtype, publicid) {

    switch (viewtype) {
      case 'invoiceview':
        this.router.navigate([`/sales/${publicid}/view`]);
        break;
      case 'invoiceedit':
        this.router.navigate([`/sales/${publicid}/edit`]);
        break;

      case 'invoicedelete':
        this.onConfirmInvoice(publicid);

        break;

      default:
        this.router.navigate([`/sales/${publicid}/view`]);

    }//end switch

  }

  /**
* this function is used to get the cancel the Invoice Details .
*/
  onConfirmInvoice(publicid) {

    this.invoicesService.deleteInvoice(publicid)
      .subscribe((result) => {

        this.GetCustomerInvoicesList();
      }, error => {
        console.log('Failed while trying to cancel the invoice Details.' + error);
      });
  } //end method









  exportAsXLSX() {

    this.setExportExcelFileData(this.excelExportData);
  }//end





  setExportExcelFileData(excelExportData) {



    var excelHeader = ["FECHA DE CREACION", "VENCIMIENTO", "EXPIRACION", "ID EMPRESA", "CLIENTE", "NOMBRE", "SUBTOTAL", "MORA", "TOTAL", "ESTADO"]

    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++)
   
    {
      var singleRec_temp = excelExportData[k];
      delete singleRec_temp['livemode'];

      delete singleRec_temp['object'];
      delete singleRec_temp['public_id'];


      columnsKeyNames = Object.keys(singleRec_temp);


      var created_temp;
      var due_datetime_temp;
      var expiration_datetime_temp;
      var external_id_temp;
      var debtor_temp;
      var creditor_temp;
      var sub_total_temp;
      var late_fee_temp;
      var total_temp;
      var status_temp;



      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {
        if (columnsKeyNames[i] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "due_datetime") {
          due_datetime_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "expiration_datetime") {
          expiration_datetime_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "external_id") {
          external_id_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "name") {
          creditor_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "creditor") {
          debtor_temp = singleRec_temp[columnsKeyNames[i]].name;
        }



        if (columnsKeyNames[i] == "total") {
          total_temp = singleRec_temp[columnsKeyNames[i]].value;

        }

        if (columnsKeyNames[i] == "sub_total") {
          sub_total_temp = singleRec_temp[columnsKeyNames[i]].value;
        }


        if (columnsKeyNames[i] == "late_fee") {
          late_fee_temp = singleRec_temp[columnsKeyNames[i]].value;
        }

        var statusEnglish;
        if (columnsKeyNames[i] == "status") {
          statusEnglish = singleRec_temp[columnsKeyNames[i]];

          switch (statusEnglish) {
            case 'NEW':
              status_temp = 'Nuevo'
              break;
            case 'PENDING':
              status_temp = 'Pendiente'
              break;
            case 'PROCESSING':
              status_temp = 'Pendiente'
              break;
            case 'PAID':
              status_temp = 'Pagado'
              break;
            case 'VOIDED':
              status_temp = 'Anulado'
              break;
            case 'EXPIRED':
              status_temp = 'Expirado'
              break;
            case 'VOIDED_CUSTOMER':
              status_temp = 'Anulado'
              break;
            case 'OVERDUE':
              status_temp = 'Vencido'
              break;
            case 'PAYMENT_ON_HOLD':
              status_temp = 'Pendiente'
              break;
            default:
              status_temp = statusEnglish;

          }//end switch

        }


      }//end for



      for (var j = 0; j < excelHeader.length; j++) {
        if (excelHeader[j] == "FECHA DE CREACION") {
          object_temp[excelHeader[j]] = created_temp
        }

        if (excelHeader[j] == "VENCIMIENTO") {
          object_temp[excelHeader[j]] = due_datetime_temp;
        }

        if (excelHeader[j] == "EXPIRACION") {
          object_temp[excelHeader[j]] = expiration_datetime_temp;
        }

        if (excelHeader[j] == "ID EMPRESA") {
          object_temp[excelHeader[j]] = external_id_temp;
        }

        if (excelHeader[j] == "CLIENTE") {
          object_temp[excelHeader[j]] = debtor_temp;
        }

        if (excelHeader[j] == "NOMBRE") {
          object_temp[excelHeader[j]] = creditor_temp;
        }

        if (excelHeader[j] == "SUBTOTAL") {
          object_temp[excelHeader[j]] = sub_total_temp;
        }


        if (excelHeader[j] == "MORA") {
          object_temp[excelHeader[j]] = late_fee_temp;
        }


        if (excelHeader[j] == "TOTAL") {
          object_temp[excelHeader[j]] = total_temp;
        }


        if (excelHeader[j] == "ESTADO") {
          object_temp[excelHeader[j]] = status_temp;
        }


      }//end for





      arrFinalData.push(object_temp);
    }

    this.excelService.exportAsExcelFile(arrFinalData, 'InvoiceList');


  }//end function


}